import { Component } from '@angular/core';

import { ApolloQueryService } from 'app/shared/apollo';
import { SYSTEM_MESSAGE_HIDE_KEY } from 'app/shared/constants/local-storage.constants';

@Component({
  selector: 'app-application-message',
  templateUrl: './application-message.component.html',
  styleUrls: ['./application-message.component.scss'],
})
export class ApplicationMessageComponent {
  messages: any[] = [];

  constructor(private apolloQueryService: ApolloQueryService) {
    const storedValue = localStorage.getItem(SYSTEM_MESSAGE_HIDE_KEY);

    this.apolloQueryService
      .apolloWatchQueryTwo('applicationMessages', {})
      .subscribe(data => {
        data.sub.unsubscribe();
        const message = data.data.company.systemMessage;
        if (!message) {
          this.messages = [];
          return;
        }

        if (storedValue && +storedValue >= +message.id) {
          return;
        }
        localStorage.setItem(SYSTEM_MESSAGE_HIDE_KEY, '');
        this.messages.push([
          {
            severity: 'info',
            summary: 'Information',
            detail: message.message,
            id: +message.id,
          },
        ]);
      });
  }

  myCloseEvent(message) {
    localStorage.setItem(SYSTEM_MESSAGE_HIDE_KEY, message[0]['id']);
  }
}
